import Dispatcher from '../../dispatcher';
import { ReduceStore } from 'flux/utils';
import { actionTypes } from '../../constants/action_types';
import { actions } from '../../constants/sidebar/actions';

const {
    SIDEBAR_ACTION
} = actionTypes;

const {
    SHOW_QUANTITY_AND_PRICE,
    HIDE_QUANTITY_AND_PRICE
} = actions;

class PdpClass extends ReduceStore {
    getInitialState() {
        return {
            quantityAndPriceRowVisible: true,
        };
    }

    reduce( state, { source, action } ) {
        const { type } = action;

        return (
            source === SIDEBAR_ACTION
                ? this.reduceSidebarAction( state, action )
                : state
        );
    }

    reduceSidebarAction( state, { type }) {
        return (
            type === SHOW_QUANTITY_AND_PRICE
                ? this.handleShowQuantityAndPriceRowAction( state )

            : type === HIDE_QUANTITY_AND_PRICE
                ? this.handleHideQuantityAndPriceAction( state )

            : state
        );
    }

    handleShowQuantityAndPriceRowAction( state ) {
        if ( !state.quantityAndPriceRowVisible ) {
            state.quantityAndPriceRowVisible = true;
            this.__emitChange();
        }

        return state;
    }

    handleHideQuantityAndPriceAction( state ) {
        if ( state.quantityAndPriceRowVisible ) {
            state.quantityAndPriceRowVisible = false;
            this.__emitChange();
        }

        return state;
    }
}

export const Pdp = new PdpClass( Dispatcher );
